import React, { useLayoutEffect } from 'react';
import HeaderV3 from '../../components/HeaderV3/headerV3.component';
import FeaturesHeroSection from './features-components/FeaturesHeroSection/featuresherosection';
import DigitalAuditWorkflowsSection from './features-components/Digital Audit Workflows/digitalauditworkflows.component';
import RealtimeCommunicationSection from './features-components/RealtimeCommunicationSection/realtimecommunicationsection.component';
import IntelligentDataManagementSection from './features-components/IntelligentDataManagementSection/intelligentdatamanagementsection';
import AdvancedCloudViewerSection from './features-components/AdvancedCloudViewerSection/advancedcloudviewer.component';
import AIDataIntegritySection from './features-components/AIDataIntegritySection/aIdataintegrity.componenet';
import UserManagementHubSection from './features-components/UserManagementHubSection/usermanagementhub.component';
import DataControlHubSection from './features-components/DataControlHubSection/DataControlHubSection';
import ScalableProjectHubSection from './features-components/ScalableProjectHubSection/scalableprojecthub';
import OrbixContact from '../../components/ContactSection/contact.component';
import FooterSection from '../../components/FooterSection/footersection.component';
import { Fragment } from "react";


function Features() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#131022';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);
  return (
    <Fragment>
    {/* main */}
    <main className="page-wrapper dark-mode">
    {/* Header  */}
    <HeaderV3 />

    {/* Hero  */}
    <FeaturesHeroSection/>

    
    {/* Digital Audit Workflows Section  */}

   <DigitalAuditWorkflowsSection/>


    {/*Realtime Communication Section  */}

    <RealtimeCommunicationSection/>


     {/*Intelligent Data Management Section  */}
    <IntelligentDataManagementSection/>

     {/*Advanced Cloud Viewer Section  */}
     <AdvancedCloudViewerSection/>

    {/*AI Data Integrity Section  */}
     <AIDataIntegritySection/>

    {/*User Managemen tHub Section  */}
     <UserManagementHubSection/>

    {/*Data Control Hub Section */}
     <DataControlHubSection/>

    {/*Scalable Project Hub Section  */}
     <ScalableProjectHubSection/>



    {/* Contact -1 */}
    <OrbixContact/>

    <FooterSection />
    </main>

    </Fragment>
  )
}

export default Features